import React from 'react';
import {
  makeStyles, Container, Typography, Button,
} from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import UserInfoSubInfo from 'common/components/UserInfoSubInfo';
import ChatIcon from '@material-ui/icons/Chat';
import { withTranslation } from 'config/i18n';
import { useLayoutState } from 'components/shared/Layout';
import useTalkJS from 'common/hooks/useTalkJs';

const useStyles = makeStyles((theme) => ({
  userInfoHolder: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      display: 'block',
      textAlign: 'center',
    },
  },
  msgBtn: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  bio: {
    color: theme.palette.secondary.light,
    marginTop: theme.spacing(0.75),
    textAlign: 'center',

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(1.625),
      textAlign: 'left',
    },
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(-2.5),

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginLeft: '0',
      flexWrap: 'wrap',
    },
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey['300'],
    marginTop: theme.spacing(1.75),
    lineHeight: 'normal',
    margin: theme.spacing(0, 2.5),

    '& svg': {
      height: theme.spacing(2),
      width: theme.spacing(2),
      marginRight: theme.spacing(0.5),
    },

    '& span': {
      lineHeight: 'normal',
    },
  },
}));

const BasicInfo = (props) => {
  const {
    t,
    userBio,
    location,
    joinDate,
    userImage,
    userName,
    verified,
    userRate,
    tripsCount,
    // userEmail,
    userID,
  } = props;
  const classes = useStyles();
  const { layoutState } = useLayoutState();

  const { openTalkJsPopup } = useTalkJS();
  const sendMsg = () => {
    const recipient = {
      user_id: userID,
      name: userName,
      // email: userEmail,
      photoUrl: userImage,
      role: 'buyer',
    };
    openTalkJsPopup(recipient);
  };
  return (
    <>
      <Container>

        <div className={classes.userInfoHolder}>
          <UserInfoSubInfo
            image={userImage}
            name={userName}
            verified={verified}
            rate={userRate}
            trips={tripsCount}
            centered
          />

          {layoutState?.current_user && (layoutState.current_user.id !== userID) && (
              <Button
                className={classes.msgBtn}
                color="secondary"
                startIcon={<ChatIcon />}
                onClick={sendMsg}
              >
                {t('fe_es_profiles:message')}
              </Button>
          )}
        </div>

        {userBio && (
        <Typography variant="body1" className={classes.bio}>
          {userBio}
        </Typography>
        )}

        <div className={classes.userInfo}>
          {location && (
          <div className={classes.info}>
            <RoomIcon />

            <Typography variant="caption" component="span">
              {location}
            </Typography>
          </div>
          )}

          <div className={classes.info}>
            <CalendarTodayIcon />

            <Typography variant="caption" component="span">
              {joinDate}
            </Typography>
          </div>
        </div>
      </Container>
    </>
  );
};

export default withTranslation('fe_es_profiles')(BasicInfo);
